import React from 'react';

import QualifyingField from '../QualifyingField';
import RadioImageGroupField from '../RadioImageGroupField';

import { FieldAttributes } from 'formik';

export type QualifyingRadioImageGroupFieldProps = {
  arrayHelpers: FieldAttributes<any>;
  name: string;
  options: { [option: string]: any }[];
  onFieldChange?: (fieldName: string, value: string) => void;
  recordDisqualification?: (name: string, error: string) => void;
  disqualificationMessage: { [key: string]: string };
};

export const QualifyingRadioImageGroupField: React.StatelessComponent<QualifyingRadioImageGroupFieldProps> = ({
  ...props
}: QualifyingRadioImageGroupFieldProps) => {
  const { arrayHelpers, name, options, onFieldChange, recordDisqualification, disqualificationMessage } = props;
  const isValid = arrayHelpers.form.values[name] !== undefined && arrayHelpers.form.errors[name] !== undefined;

  return (
    <QualifyingField
      errors={arrayHelpers.form.errors}
      name={name}
      isValid={!isValid}
      recordDisqualification={recordDisqualification}
      disqualificationMessage={disqualificationMessage}
    >
      <RadioImageGroupField
        name={name}
        touched={arrayHelpers.form.errors[name] !== undefined && arrayHelpers.form.touched[name]}
        isValid={isValid}
        options={options}
        arrayHelpers={arrayHelpers}
        onFieldChange={onFieldChange}
      />
    </QualifyingField>
  );
};
